export interface IProps {}

export enum ImageType {
  SQUARE_SMALL = "squareSmall",
  RECTANGULAR_LONG = "rectangularLong",
  RECTANGULAR_TALL = "rectangularTall",
}
